<template>
  <div>
    <van-popup
      v-model="aashow"
      closeable
      position="bottom"
      class="answer__right--popup"
      duration="0.05"
    >
      <div class="inner__box">
        <div class="icon__box">
          <span class="icon"></span>
        </div>
        <div class="title">您的作业宝服务已过期</div>
        <div class="description">不限页数看答案功能已关闭</div>
        <div class="button__box">
          <div class="button" @click="toPayPage">
            <span>立即续费</span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { register } from '@/plugin/popup'
export default {

  data() {
    return {
      aashow: false,
      imageUrl: null,
      link: null,
      needAdPrint: null
    }
  },
  mounted() {
    register({
      name: 'AnswerRights',
      open: ({ afterClose }) => {
        this.afterClose = afterClose
        this.aashow = true
      },
      close: () => {
        this.close()
      }
    })
  },
  methods: {
    close() {
      this.aashow = false
      if (this.afterClose) {
        this.afterClose()
      }
    },
    toPayPage() {
      // 百度统计
      if (window._hmt) {
        window._hmt.push(['_trackEvent', 'funcTracker', 'click', '过期弹窗点击_答案核对'])
      }
      window.location.href =
        '/cms/webapp/home/user/userCenter.html#/payAnswer?channel=daanye_gqtc_gn'
    }
  }
}
</script>

<style lang="scss">
.answer__right--popup {
  border-radius: 0.27rem 0.27rem 0 0;
  padding-top: 0.83rem;
  padding-bottom: 0.65rem;
  .inner__box {
    .van-icon-cross::before {
      font-size: 0.31rem;
    }
    & > div {
      display: flex;
      justify-content: center;
    }
    .icon__box {
      .icon {
        height: 1.11rem;
        width: 1.2rem;
        background: #000;
        background: url('./img/reading.png') no-repeat;
        background-size: contain;
      }
    }
    .title,
    .description {
      margin-top: 0.44rem;
      font-size: 0.45rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 0.61rem;
    }
    .description {
      margin-top: 0.1rem;
      font-weight: normal;
      color: #999999;
      font-size: 0.37rem;
    }
    .button {
      margin-top: 0.6rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 9.2rem;
      height: 1.33rem;
      background: linear-gradient(to right, #fe873e, #ef4246);
      border-radius: 3px;
      font-size: 0.45rem;
      color: #fff;
    }
  }
}
</style>
